;(function(window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Layout = APP.module('Layout');

	Layout.NotFound = Marionette.ItemView.extend({
		model    : new Backbone.Model(),
		className: 'not-found-404-outer-wrapper',
		template : JST.notFound
	});

}(window, APP, Backbone, Marionette, $, _));